import { useTran } from "@/hooks";

const ESGFrameworkOverview = ({
  framework,
  reportName,
  frameworkInfo,
  totalDisclosures,
  completionPercentage,
  orgName,
}) => {
  const { t } = useTran();
  return (
    <div className="esg-avoid-break bg-white p-12">
      <h2 className="mb-6 text-3xl font-bold text-slate-900">
        {t("Framework Overview")}
      </h2>

      <div className="mb-6 rounded-lg border border-slate-200 bg-slate-50 p-6">
        <div className="esg-framework-grid grid grid-cols-2 gap-6">
          <div>
            <p className="mb-1 text-sm font-semibold text-slate-600">
              {t("Framework")}
            </p>
            <p className="text-lg font-bold text-slate-900">{framework}</p>
          </div>
          {orgName ? (
            <div>
              <p className="mb-1 text-sm font-semibold text-slate-600">
                {t("Organization")}
              </p>
              <p className="text-lg font-bold text-slate-900">{orgName}</p>
            </div>
          ) : null}
          <div>
            <p className="mb-1 text-sm font-semibold text-slate-600">
              {t("Report Name")}
            </p>
            <p className="text-lg font-bold text-slate-900">
              {reportName || t("Untitled Report")}
            </p>
          </div>
          <div>
            <p className="mb-1 text-sm font-semibold text-slate-600">
              {t("Total Disclosures")}
            </p>
            <p className="text-lg font-bold text-slate-900">
              {totalDisclosures}
            </p>
          </div>
          <div>
            <p className="mb-1 text-sm font-semibold text-slate-600">
              {t("Completion")}
            </p>
            <p className="text-lg font-bold text-emerald-600">
              {completionPercentage}%
            </p>
          </div>
        </div>

        {frameworkInfo?.summary ? (
          <div className="mt-6 border-t border-slate-200 pt-6">
            <p className="mb-2 text-sm font-semibold text-slate-600">
              {t("Framework Description")}
            </p>
            <p className="text-sm text-slate-700 leading-relaxed">
              {frameworkInfo.summary}
            </p>
          </div>
        ) : null}
      </div>

      <div className="rounded-lg border border-blue-200 bg-blue-50 p-4">
        <p className="text-sm text-blue-900 leading-relaxed">
          <span className="font-semibold">{t("About this report")}:</span>{" "}
          {t(
            "This document provides a comprehensive view of our ESG disclosures structured according to the {{framework}} framework requirements.",
            { framework },
          )}
        </p>
      </div>
    </div>
  );
};

export default ESGFrameworkOverview;
